import React from 'react'
import '../../styles/SwiftBankingStyles/cranethree.css'
import craneOne from './../../resources/SwiftBankingResources/crane-1.svg'
import hookOne from './../../resources/SwiftBankingResources/hook-1.svg'
import Truck from './../../resources/SwiftBankingResources/crane-3-truck.svg'

import platLeft from './../../resources/HomePageResources/platform-down-left.svg'
import platRight from './../../resources/HomePageResources/platform-down-right.svg'


export default class CraneThree extends React.Component{
    render(){
        return(
            <section className="craneone__container">
                <div className="sb__c3">
                    <div className="sb-c3__box">
                        <div className="sb__box">
                            <div className="sb__box-title">Crypto<br/>Banking</div>
                            <div className='text sb__box-text'>
                                Deposit, spend and <br/>
                                borrow crypto-<br/>
                                currencies or receive<br/>
                                interest by keeping<br/>
                                them dormant
                            </div>
                            {/*<div className="sb__read-more">Read more</div>*/}
                        </div>
                        <div className="sb__platform">
                            <img className="sb__plat-left" src={platLeft} />
                            <div className="sb__plat__middle"/>
                            <img className="sb__plat-right" src={platRight} />
                        </div>
                    </div>

                    <img src={Truck} className="sb-c3__truck" />
                    <div className="sb-c3__platform">
                        <img className="sb-c3__plat-left" src={platLeft} />
                        <div className="sb-c3__plat__middle"/>
                        <img className="sb-c3__plat-right" src={platRight} />
                    </div>
                </div>


            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SwiftBanking/CraneThree.js